import { Mapping } from 'api/MappingsAPI';
import { useCustomEventsQueryContext } from 'modules/customEvents/contexts';
import { GenericDataType } from 'modules/domains';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useModalContext } from 'utils/contexts/modal';
import { useSearchParamsContext } from '../contexts';
import { useCustomEventDetailsContext } from '../contexts/CustomEventDetailsContext';
import { FieldDataType, ModalAction } from '../types';
import { TableActions } from './Table/TableActions';
import { TablePagination } from './Table/TablePagination';
import { CustomEventPageHeader, CustomEventTable } from './customEventDetails';

/**
 * Custom Event Details
 */
export const CustomEventDetailsPage = () => {
  const { customEvents } = useCustomEventsQueryContext();
  const { debouncedSearch, resetSearchParams } = useSearchParamsContext();
  const { showModal } = useModalContext();
  const { customEventName } = useParams<{ customEventName: string }>();

  const {
    customEventDetails,
    customEventDetailsError,
    isLoadingCustomEventDetails,
    refetchCustomEventDetails,
  } = useCustomEventDetailsContext();

  const currentCustomEvent = customEvents.find((event) => event.eventName === customEventName);
  const filteredMappings = customEventDetails.filter((mapping: Mapping) =>
    mapping.fieldName.toLowerCase().includes(debouncedSearch.toLowerCase()),
  );

  const onCreateNewField = (fieldName?: string) =>
    showModal({
      action: ModalAction.NEW_EVENT_FIELD,
      payload: { parentName: fieldName },
    });

  useEffect(() => {
    return () => resetSearchParams();
  }, []);

  return (
    <>
      <CustomEventPageHeader
        currentCustomEvent={currentCustomEvent}
        customEventName={customEventName}
      />
      <TableActions
        areFiltersEnabled={false}
        dataType={GenericDataType.CustomEvent}
        fieldType={FieldDataType.CustomEventFields}
        onCreateNewField={() => onCreateNewField()}
        refetchFields={refetchCustomEventDetails}
      />
      <CustomEventTable
        hasError={Boolean(customEventDetailsError)}
        handleCreateNewField={onCreateNewField}
        isLoading={isLoadingCustomEventDetails}
        mappings={filteredMappings}
        totalCount={customEventDetails.length}
      />
      <TablePagination numItems={customEventDetails.length} />
    </>
  );
};
